import { VIDEOS_QUERY_PARAM } from '../videos.const'

export function parseTopicsFromSearchParams(searchParams: URLSearchParams): string[] {
  const raw = searchParams.get(VIDEOS_QUERY_PARAM)
  if (!raw) {
    return []
  }

  return raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)
}

export function buildTopicsQuery(selectedTopicIds: string[]): string {
  if (selectedTopicIds.length === 0) {
    return ''
  }
  const params = new URLSearchParams()
  params.set(VIDEOS_QUERY_PARAM, selectedTopicIds.join(','))
  return `?${params.toString()}`
}
